export default __webpack_public_path__ + "static/media/capabilityWalletFilled.eacf7ff4.svg";